let sidebarBtnEl = document.getElementById('jsSidebarBtn'),
    sidebarCloseEl = document.getElementById('jsSidebarClose'),
    sidebarEl = document.getElementById('jsSidebarSticky'),
    anchorEls = document.querySelectorAll('li .jsAnchor'),
    anchorTabEls = document.querySelectorAll('#jsAnchors a');
let cardHeadingResizeFrame = null;

function syncCardHeadingHeights() {
    const cardGroups = document.querySelectorAll('.ct-section__group');

    cardGroups.forEach(group => {
        const cards = [...group.querySelectorAll(':scope > .ct-section__card')];
        const headings = cards
            .map(card => card.querySelector('h4'))
            .filter(Boolean);

        headings.forEach(heading => {
            heading.style.minHeight = '';
        });

        if (window.innerWidth <= 768) return;

        for (let index = 0; index < cards.length; index += 2) {
            const rowHeadings = cards
                .slice(index, index + 2)
                .map(card => card.querySelector('h4'))
                .filter(Boolean);
            const rowHeight = Math.max(...rowHeadings.map(heading => heading.offsetHeight));

            rowHeadings.forEach(heading => {
                heading.style.minHeight = `${rowHeight}px`;
            });
        }
    });
}

function scheduleCardHeadingSync() {
    window.cancelAnimationFrame(cardHeadingResizeFrame);
    cardHeadingResizeFrame = window.requestAnimationFrame(syncCardHeadingHeights);
}

scheduleCardHeadingSync();
document.fonts?.ready.then(scheduleCardHeadingSync);

function showNavBtn() {
    sidebarBtnEl?.classList.toggle('visible', window.scrollY > 200);
}

function setSidebarVisibility(isVisible, returnFocus = false) {
    if (!sidebarEl || !sidebarBtnEl) return;

    sidebarEl.classList.toggle('visible', isVisible);
    sidebarBtnEl.setAttribute('aria-expanded', String(isVisible));
    document.body.classList.toggle('training-menu-open', isVisible);

    if (isVisible) {
        sidebarCloseEl?.focus();
    } else if (returnFocus) {
        sidebarBtnEl.focus();
    }
}

function showNav() {
    sidebarBtnEl?.addEventListener('click', () => setSidebarVisibility(true));
    sidebarCloseEl?.addEventListener('click', () => setSidebarVisibility(false, true));
    sidebarEl?.querySelectorAll('.jsAnchor').forEach(anchor => {
        anchor.addEventListener('click', () => setSidebarVisibility(false));
    });
    document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && sidebarEl?.classList.contains('visible')) {
            setSidebarVisibility(false, true);
        }
    });
}

function anchorClick(el) {
    anchorTabEls.forEach(anchor => {
        anchor.classList.remove('current');
    });
    el.classList.add('current');
    if (window.innerWidth <= 576) {
        el.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
        });
    }
}

function activeAnchor() {
    let currentEl = null;
    anchorEls.forEach(anchor => {
        const section = document.querySelector(`#${anchor.dataset.anchor}`);
        if (!section || anchor.dataset.anchor === 'price') return;

        const { top, bottom } = section.getBoundingClientRect();

        if (top <= 150 && bottom > 150) {
            currentEl = anchor;
        }

    });

    anchorEls.forEach(anchor => {
        anchor.classList.toggle('current', anchor === currentEl);
    });
}

window.addEventListener('load', () => {
    sidebarBtnEl = document.getElementById('jsSidebarBtn');
    sidebarCloseEl = document.getElementById('jsSidebarClose');
    sidebarEl = document.getElementById('jsSidebarSticky');
    anchorEls = document.querySelectorAll('li .jsAnchor');
    anchorTabEls = document.querySelectorAll('#jsAnchors a');
    anchorTabEls.forEach(anchor => {
        anchor.addEventListener('click', () => {
            anchorClick(anchor);
        });
    });
    showNavBtn();
    showNav();
    activeAnchor();
    scheduleCardHeadingSync();
});

window.addEventListener('scroll', () => {
    showNavBtn();
    activeAnchor();
});

window.addEventListener('resize', () => {
    scheduleCardHeadingSync();

    if (window.innerWidth > 576 && sidebarEl?.classList.contains('visible')) {
        setSidebarVisibility(false);
    }
});
